import React from 'react';

import config from 'config';
import NavActions from 'lib/NavActions';
import Utils from 'lib/Utils';
import { ContainerConstants } from '../../lib/Constants';

import TermsAndConditionsStyles from './_TermsAndConditionsStyles.module.scss';

const TermsAndConditions = (): JSX.Element => {
    const {
        privacyPolicyExternalLink,
    } = config;

    const {
        navToPrivacyPolicy,
    } = NavActions;

    const {
        GTM: {
            triggerPageView,
        },
    } = Utils;

    const {
        termsAndConditionsPage: {
            introductionCopy,
            termsAndConditionsCopy,
            privacyPolicyCopy,
        },
    } = ContainerConstants;

    triggerPageView();

    const renderTermsAndConditions = () => {
        return termsAndConditionsCopy.map((copy, index) => {
            const {
                body,
                steps,
                alphabetList,
                productShape,
                myDay,
                biofinity,
                bulletList,
                secondBulletList,
                bulletListBoldedWords,
            } = copy;

            if (index === 0) {
                return (
                    <div
                        key={index.toString().concat(body.substring(0, 10))}
                        className={TermsAndConditionsStyles['subcontainer-items']}
                    >
                        <p style={{ color: 'black' }}>
                            {copy?.header}
                        </p>
                        <p>
                            {body}
                            <span style={{ color: 'black' }}>{copy?.bold}</span>
                            {copy?.body2}
                        </p>
                    </div>
                );
            }
            if (index === 2) {
                return (
                    <div
                        key={index.toString().concat(body.substring(0, 10))}
                        className={TermsAndConditionsStyles['subcontainer-items']}
                    >
                        <p style={{ color: 'black' }}>
                            {copy?.header}
                        </p>
                        <p>
                            {body}
                        </p>
                        {bulletListBoldedWords?.map((listItem) => (
                            <span
                                className={TermsAndConditionsStyles['bullet-list-item']}
                                key={listItem.body1}
                            >
                                {listItem.bold1 ? (
                                    <p>
                                        {listItem.body1}
                                        <span style={{ color: 'black' }}>{listItem.bold1}</span>
                                        {listItem.body2}
                                        <span style={{ color: 'black' }}>{listItem.bold2}</span>
                                        {listItem.body3}
                                        <span style={{ color: 'black' }}>{listItem.bold3}</span>
                                        {listItem.body4}
                                    </p>
                                ) : (
                                    listItem.body1
                                )}
                            </span>
                        ))}
                    </div>
                );
            }
            if (index === 4) {
                return (
                    <div
                        key={index.toString().concat(body.substring(0, 10))}
                        className={TermsAndConditionsStyles['subcontainer-items']}
                    >
                        <p style={{ color: 'black' }}>
                            {body}
                        </p>
                        {bulletList?.map((listItem, idx) => {
                            const { item } = listItem;
                            return (
                                <span
                                    className={TermsAndConditionsStyles['bullet-list-item']}
                                    key={item.slice(0, 20).concat(idx.toString())}
                                >
                                    {item}
                                </span>
                            );
                        })}
                        <p>Example:</p>
                        {secondBulletList?.map((listItem, idx) => {
                            const { item } = listItem;
                            return (
                                <span
                                    className={TermsAndConditionsStyles['second-bullet-list-item']}
                                    key={item.slice(0, 20).concat(idx.toString())}
                                >
                                    {item}
                                </span>
                            );
                        })}
                    </div>
                );
            }
            if (index === 6) {
                return (
                    <div
                        key={index.toString().concat(body.substring(0, 10))}
                        className={TermsAndConditionsStyles['subcontainer-items']}
                    >
                        <p style={{ color: 'black' }}>
                            {copy?.header}
                        </p>
                        <p>
                            {body}
                        </p>
                        {bulletList?.map((listItem, idx) => {
                            const { item } = listItem;
                            return (
                                <span
                                    className={TermsAndConditionsStyles['bullet-list-item']}
                                    key={item.slice(0, 20).concat(idx.toString())}
                                >
                                    {item}
                                </span>
                            );
                        })}
                        <p>
                            {copy?.body2}
                            <span style={{ color: 'black' }}>{copy?.bold1}</span>
                            {copy?.body3}
                        </p>
                    </div>
                );
            }
            if (index === 8 || index === 10) {
                return (
                    <div
                        key={index.toString().concat(body.substring(0, 10))}
                        className={TermsAndConditionsStyles['subcontainer-items']}
                    >
                        <p style={{ color: 'black' }}>
                            {body}
                        </p>
                        {alphabetList?.map((listItem, idx) => {
                            const { item } = listItem;
                            return (
                                <span
                                    className={TermsAndConditionsStyles['alphabet-list-item']}
                                    key={item.slice(0, 20).concat(idx.toString())}
                                >
                                    {item}
                                </span>
                            );
                        })}
                    </div>
                );
            }

            return (
                <div
                    key={index.toString().concat(body.substring(0, 10))}
                    className={TermsAndConditionsStyles['subcontainer-items']}
                >
                    <p style={{ color: 'black' }}>
                        {copy?.header}
                    </p>
                    <p>
                        {body}
                    </p>

                    {steps?.map((step, i) => {
                        const { item } = step;
                        if (i === 2) {
                            return (
                                <span key={item.slice(0, 20).concat(i.toString())}>
                                    <span style={{ color: 'black' }} className={TermsAndConditionsStyles.step}>
                                        STEP
                                        {' '}
                                        {i + 1}
                                        :
                                    </span>

                                    <span>
                                        {item}

                                        {'bulletList' in step && step.bulletList && (
                                            <span>
                                                {step.bulletList.map((listItem) => (
                                                    <p className={TermsAndConditionsStyles['bullet-list-item']}>
                                                        {listItem.item}
                                                    </p>
                                                ))}
                                            </span>
                                        )}
                                    </span>
                                </span>
                            );
                        }

                        return (
                            <span key={item.slice(0, 20).concat(i.toString())}>
                                <span style={{ color: 'black' }} className={TermsAndConditionsStyles.step}>
                                    STEP
                                    {' '}
                                    {i + 1}
                                    :
                                </span>

                                <span>
                                    {item}
                                </span>
                            </span>
                        );
                    })}

                    {productShape && (
                        <table className={TermsAndConditionsStyles['purchase-tier-table']}>
                            <tbody>
                                <tr>
                                    <td rowSpan={3} className={TermsAndConditionsStyles['first-column']}>Purchase criteria</td>
                                    <td colSpan={4} style={{ color: 'black' }}>GrabGift e-voucher amount</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={TermsAndConditionsStyles.boxes}>2 boxes</td>
                                    <td colSpan={2} className={TermsAndConditionsStyles.boxes}>4 boxes</td>
                                </tr>
                                {productShape.map((shape) => (
                                    <tr key={shape.sphere}>
                                        <td>{shape.sphere}</td>
                                        <td>{shape.toric}</td>
                                        <td>{shape.sphere}</td>
                                        <td>{shape.toric}</td>
                                    </tr>
                                ))}
                                {myDay.map((product) => (
                                    <tr key={product.productType}>
                                        <td className={TermsAndConditionsStyles['first-column']}>{product.productType}</td>
                                        <td>{product.amount}</td>
                                        <td>{product.amount2}</td>
                                        <td>{product.amount3}</td>
                                        <td>{product.amount4}</td>
                                    </tr>
                                ))}
                                {biofinity.map((product) => (
                                    <tr key={product.productType}>
                                        <td className={TermsAndConditionsStyles['first-column']}>{product.productType}</td>
                                        <td>{product.amount}</td>
                                        <td>{product.amount2}</td>
                                        <td colSpan={2}>{product.amount3}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {alphabetList?.map((listItem, idx) => {
                        const { item } = listItem;
                        return (
                            <span
                                className={TermsAndConditionsStyles['alphabet-list-item']}
                                key={item.slice(0, 20).concat(idx.toString())}
                            >
                                {item}
                            </span>
                        );
                    })}
                    {bulletList?.map((listItem, idx) => {
                        const { item } = listItem;
                        return (
                            <span
                                className={TermsAndConditionsStyles['bullet-list-item']}
                                key={item.slice(0, 20).concat(idx.toString())}
                            >
                                {item}
                            </span>
                        );
                    })}
                </div>
            );
        });
    };

    const renderPrivacyPolicy = () => {
        const hereText = 'here';

        return (
            <p className={TermsAndConditionsStyles['privacy-policy-container']}>
                {privacyPolicyCopy.substring(0, privacyPolicyCopy.indexOf(hereText))}

                <a
                    href={privacyPolicyExternalLink}
                    onClick={(e) => {
                        e.preventDefault();
                        navToPrivacyPolicy();
                    }}
                >
                    {hereText}
                    {' '}
                </a>

                {privacyPolicyCopy.substring(privacyPolicyCopy.indexOf(hereText) + hereText.length)}
            </p>
        );
    };

    return (
        <div className={TermsAndConditionsStyles.container}>
            <div className={TermsAndConditionsStyles.container__leftBackground} />
            <div className={TermsAndConditionsStyles.container__rightBackground} />
            <div className={TermsAndConditionsStyles.container__bottomBackground} />
            <h1>
                Terms & Conditions
            </h1>

            <div className={TermsAndConditionsStyles.subcontainer}>
                <div className={TermsAndConditionsStyles.introduction}>
                    <p>
                        {introductionCopy}
                    </p>
                </div>

                {renderTermsAndConditions()}

                <p>
                    For more information on CooperVision Singapore Privacy Policy, please refer to:
                    <br />
                    <a
                        href='https://coopervision.com.sg/privacy-policy'
                        target='_blank'
                        rel='noreferrer'
                    >
                        https://coopervision.com.sg/privacy-policy
                    </a>
                </p>
            </div>

        </div>
    );
};

export default TermsAndConditions;
